import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const hasRelationship = (workingRef, displaySuccess, logEvent, displayErrorMessage) => (rel) => {
  const onClickStartReset = async () => {
    if (workingRef.current === true) {
      return;
    }

    try {
    // There is no GET for this endpoint because there is literally nothing to return
      const [resultResource] = await rel.link('related').post({}, { deprecatedAllowAlterOfRelation: true });
      displaySuccess(resultResource.attr('message'));
      logEvent('mfa reset initiated');
    } catch (err) {
      displayErrorMessage(err);
    }

    // eslint-disable-next-line no-param-reassign
    workingRef.current = false;
  };

  return {
    onClickStartReset,
    relationship: rel,
    ok: true,
  };
};

const hasNoRelationship = () => () => {
  return {
    onClickStartReset: null,
    relationship: null,
    ok: false,
  };
};

export const useMFAResetInitiation = (resource, relationshipName) => {
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();
  const { logEvent } = useEventTrackingLogEvent();

  const workingRef = React.useRef(false);

  return resource.withRelationship(
    relationshipName,
    hasRelationship(workingRef, displaySuccess, logEvent, displayErrorMessage),
    hasNoRelationship(),
  );
};
